import { jsx as t } from "react/jsx-runtime";
import s from "./roche-tag.module.scss.js";
const c = ({ tag: r, href: a, onClick: e, ariaLabel: o }) => /* @__PURE__ */ t("a", { href: a, className: s.tag, onClick: e, "aria-label": o, children: r });
export {
  c as RocheUITag
};
